import React, { useCallback, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'
import { SwapLeftOutlined, SwapRightOutlined } from '@ant-design/icons'

import { UserCard } from '~/components/business/UserCard'
import { Container } from '~/components/ui/Container'

import 'swiper/css'
import { getCreatorList_creatorList_edges_node } from '~/graphqls/types'

const StyledCreatorModule = styled.div`
  position: relative;
  .switch-btn {
    border-width: 2px;
    border-style: solid;
    color: ${props => props.theme.dark4};
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    &.switch-btn-prev {
      position: absolute;
      top: 109px;
      left: 50%;
      margin-left: -620px;
      border-color: rgba(0, 0, 0, 0);
    }
    &.switch-btn-next {
      position: absolute;
      top: 109px;
      right: 50%;
      margin-right: -620px;
      margin-left: 16px;
      border-color: ${props => props.theme.light1};
    }
  }
`

const StyledSwiper = styled(Swiper)``

export const CreatorModule: React.FC<{
  data: getCreatorList_creatorList_edges_node[]
}> = ({ data }) => {
  const swiperRef = useRef<any>(null)

  const onPrev = useCallback(() => {
    swiperRef.current?.children?.[0]?.swiper?.slidePrev()
  }, [])

  const onNext = useCallback(() => {
    swiperRef.current?.children?.[0]?.swiper?.slideNext()
  }, [])

  return (
    <StyledCreatorModule>
      <Container>
        <div ref={swiperRef}>
          <StyledSwiper loop={true} slidesPerView={4} spaceBetween={32}>
            {data.map(creator => (
              <SwiperSlide key={creator?.base?.uid}>
                <UserCard style={{ marginBottom: 0 }} data={creator} />
              </SwiperSlide>
            ))}
          </StyledSwiper>
        </div>
        <div className="switch-btn switch-btn-prev" onClick={onPrev}>
          <SwapLeftOutlined style={{ fontSize: 24 }} />
        </div>
        <div className="switch-btn switch-btn-next" onClick={onNext}>
          <SwapRightOutlined style={{ fontSize: 24 }} />
        </div>
      </Container>
    </StyledCreatorModule>
  )
}
